import Brand from "../../../../../shared/components/Brand";
import Icons from "../../../../../shared/constants/icon.constant";
import SolidIconBuilder from "../../../../../shared/helpers/SolidIconBuilder";

interface CreditCardProps {
  name: string;
  cardNumber: string;
}

export default function CreditCard({
  name,
  cardNumber,
}: Readonly<CreditCardProps>) {
  return (
    <div className="relative h-53 w-full rounded-2xl overflow-hidden">
      <img
        src="/bg-credit-card.svg"
        alt="Credit Card"
        className="h-auto w-full absolute"
      />
      <div className="absolute -right-10 -bottom-7">
        <SolidIconBuilder
          icon={Icons.BrandLogo({ width: 150, height: 150 })}
          color="#073c7c"
        />
      </div>
      <div className="relative z-10 p-6 h-full">
        <div className="text-white flex flex-col h-full w-full justify-between">
          <div className="flex justify-between">
            <Brand size="md" />
            <img src="/icon-visa.svg" alt="visa" />
          </div>
          <div className="flex flex-col">
            <div className="text-2xl">{cardNumber}</div>
            <div className="text-lg uppercase">{name}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
